import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nProvider";
import { SEO } from "@/components/SEO";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { InternalLinks } from "@/components/InternalLinks";
import { guides } from "@/data/guides";
import { guidePath } from "@/lib/format";

export function GuidesHubPage() {
  const { t, lang, prefix } = useI18n();
  const isSv = lang === "sv";
  const title = isSv ? "Casino- och bettingguider" : "Casino and betting guides";
  const desc = isSv
    ? "Lär dig regler, omsättningskrav, spelautomater, RTP, bonuser, betting och esports."
    : "Learn rules, wagering, slots, RTP, bonuses, betting and esports.";

  const grouped: Record<string, typeof guides> = {};
  guides.forEach((g) => {
    grouped[g.category] = grouped[g.category] || [];
    grouped[g.category].push(g);
  });

  return (
    <div className="container-page py-8">
      <SEO title={title} description={desc} />
      <Breadcrumbs items={[{ label: t("nav.home"), href: prefix }, { label: title }]} />
      <h1 className="mt-3 text-3xl font-extrabold md:text-4xl">{title}</h1>
      <p className="mt-2 max-w-3xl text-ink-700">{desc}</p>

      <div className="mt-6 space-y-8">
        {Object.entries(grouped).map(([cat, list]) => (
          <section key={cat}>
            <h2 className="text-2xl font-bold capitalize">{cat}</h2>
            <div className="mt-3 grid gap-3 md:grid-cols-2 lg:grid-cols-3">
              {list.map((g) => (
                <Link
                  key={g.id}
                  to={guidePath(prefix, lang, isSv ? g.slug_sv : g.slug_en)}
                  className="card no-underline p-5 transition hover:shadow-md"
                >
                  <h3 className="text-lg font-semibold">{isSv ? g.title_sv : g.title_en}</h3>
                  <p className="mt-1 text-sm text-ink-700">
                    {isSv ? g.excerpt_sv : g.excerpt_en}
                  </p>
                </Link>
              ))}
            </div>
          </section>
        ))}
      </div>

      <InternalLinks context="guides-hub" />
    </div>
  );
}
